export default {
  CartaoVigente: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "cartao-vigente"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/CartaoVigente.js
// module id = yeam
// module chunks = 18